import React from "react";

export const MessageRedirectForm = () => {
    return <form action="/redirect/messageredirecttourl" method="POST" name="returnForm" className="d-none" >
        <input type="text" name="url" />
        <input type="text" name="message" />
        <input type="text" name="overrideCache" />
    </form >;
};